/**
 * Film Grain Effect
 * Ported from fafo-kit. Applies pixel-level noise to a canvas context.
 */

/**
 * Apply film grain noise to the canvas.
 * @param {CanvasRenderingContext2D} ctx
 * @param {number} w - canvas width
 * @param {number} h - canvas height
 * @param {boolean} isDark - whether the background is dark (affects intensity)
 * @param {number} density - 1-100, fraction of pixels that receive noise
 * @param {number} opacity - 1-100, intensity of the noise
 */
export function applyGrain(ctx, w, h, isDark, density, opacity) {
  const baseIntensity = isDark ? 22 : 14;
  const intensity = baseIntensity * (opacity / 60);
  const threshold = density / 100;
  const imageData = ctx.getImageData(0, 0, w, h);
  const d = imageData.data;
  const len = d.length;
  let s = 12345;
  for (let i = 0; i < len; i += 4) {
    s ^= s << 13; s ^= s >> 17; s ^= s << 5;
    if (((s >>> 8) & 0xff) / 255 > threshold) continue;
    const noise = ((s & 0xff) / 255 - 0.5) * 2 * intensity;
    d[i]     = Math.min(255, Math.max(0, d[i] + noise));
    d[i + 1] = Math.min(255, Math.max(0, d[i + 1] + noise));
    d[i + 2] = Math.min(255, Math.max(0, d[i + 2] + noise));
  }
  ctx.putImageData(imageData, 0, 0);
}
